import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=618deb4b&scoped=true"
import script from "./Coupons.vue?vue&type=script&lang=js"
export * from "./Coupons.vue?vue&type=script&lang=js"
import style0 from "./Coupons.vue?vue&type=style&index=0&id=618deb4b&prod&lang=css"
import style1 from "./Coupons.vue?vue&type=style&index=1&id=618deb4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618deb4b",
  null
  
)

export default component.exports